import $ from "jquery";

import "slick-carousel";

import accordion from "./components/_accordion";
import filters from "./components/_filters";
import productImages from "./components/_product-images";
import productSiblings from "./components/_product-siblings";
import ratingActions from "./components/_rating-actions";
import ratingsForm from "./components/_ratings-form";
import milkNotice from "./components/_milk-notice";
import mealPlanner from "./components/_meal-planner";

ProductManager.settings.compareList.listUrl = location.pathname + location.search + (location.search ? "&" : "?") + "type=201702&tx_pxaproductmanager_pi1%5Baction%5D=loadCompareList";

$(function () {
    accordion();
    filters();
    productImages();
    productSiblings();
    ratingActions();
    ratingsForm();
    milkNotice();
    mealPlanner();
});
